import { render } from "./DialogDeleteNotice.vue?vue&type=template&id=02cda453"
import script from "./DialogDeleteNotice.vue?vue&type=script&lang=js"
export * from "./DialogDeleteNotice.vue?vue&type=script&lang=js"

import "./DialogDeleteNotice.vue?vue&type=style&index=0&id=02cda453&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__